import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { active: String }

  connect() {
    const defaultRole = this.activeValue || this.panelTargets[0]?.dataset.panel
    if (defaultRole) {
      this.show(defaultRole)
    }
  }

  showPanel(event) {
    event.preventDefault()
    const role = event.currentTarget.dataset.role
    if (role) {
      this.show(role)
    }
  }

  show(role) {
    this.activeValue = role

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.panel !== role)
    })

    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.role === role
      const pill = tab.querySelector("[data-plan-tab-pill]") || tab

      pill.classList.toggle("bg-white", isActive)
      pill.classList.toggle("text-[#191A23]", isActive)
      pill.classList.toggle("shadow-sm", isActive)
      pill.classList.toggle("text-[#191A23]/60", !isActive)
      tab.setAttribute("aria-pressed", String(isActive))
    })
  }
}
